export default __webpack_public_path__ + "static/coinbaseWalletIcon-a3a7d7fd2e88e9cbec769e827507b863.svg";